import React from 'react';

const BASE_BORDER = '2px solid #4f46e5';
const DRAG_BORDER = '2px solid #a78bfa';

export const getBadgeStyles = (
  positionY: number,
  isDragging: boolean
): React.CSSProperties => ({
  position: 'fixed',
  top: `${positionY}%`,
  right: '0',
  transform: 'translateY(-50%)',
  writingMode: 'vertical-rl',
  textOrientation: 'mixed',
  background: isDragging
    ? 'linear-gradient(180deg, #1a1a2e 0%, #16213e 100%)'
    : 'linear-gradient(180deg, #2d2d2d 0%, #1a1a1a 100%)',
  color: isDragging ? '#a78bfa' : '#e2e8f0',
  padding: '16px 7px',
  borderTopLeftRadius: '10px',
  borderBottomLeftRadius: '10px',
  fontSize: '11px',
  fontWeight: '700',
  letterSpacing: '1px',
  borderLeft: isDragging ? DRAG_BORDER : BASE_BORDER,
  borderTop: isDragging ? DRAG_BORDER : BASE_BORDER,
  borderBottom: isDragging ? DRAG_BORDER : BASE_BORDER,
  zIndex: 99999,
  userSelect: 'none',
  boxShadow: isDragging
    ? '-6px 0 20px rgba(167, 139, 250, 0.3)'
    : '-3px 0 10px rgba(79, 70, 229, 0.2)',
  transition: isDragging
    ? 'background 0.1s, box-shadow 0.1s, color 0.1s, border-color 0.1s'
    : 'background 0.2s, box-shadow 0.2s, color 0.2s, border-color 0.2s',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  pointerEvents: 'all',
});
